<template>
<div>
  <Layout :page="'Tồn kho ban đầu'" @submit="submit = $event"
v-if="dataPermission && dataPermission.includes('NSH_INV_ITEM_CHECKIN')">
    <ValidationObserver ref="observerItems">
      <b-form>
        <div class="Card">
          <LayoutCard v-for="(inventory, index) in Inventory" :key="index">
            <LayoutFieldSet>
              <LayoutField>
                <template #label>Chi nhánh </template>
                <template #input>
                  <BaseSelect
                    v-model="inventory.locationName"
                    :options="listLocation"
                                         
                    label="name"
                    :disabled="true"
                    @select="inventoryId = $event.coInventoryId"
                  />
                </template>
              </LayoutField>
              <LayoutField>
                <template #label>Kho </template>
                <template #input>
                  <BaseSelect
                    v-model="inventory.inventoryName"
                    :options="listInventory"
                    :hideRemove="true"
                    :disabled="true"
                    label="name"
                    @select="inventoryId = $event.coInventoryId"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>

            <LayoutTable
              :items="inventory.lineItemReqs" 
              :fields="fieldInventory.filter(e => e.show)"
            >
              <template #header-edit>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="cursor: pointer"
                  @click="showPopup('Cai-dat-hien-thi')"
                >
                  <path
                    d="M6.16016 9.50391C6.85449 9.50391 7.4082 8.9502 7.4082 8.25586C7.4082 7.57031 6.85449 7.00781 6.16016 7.00781C5.47461 7.00781 4.91211 7.57031 4.91211 8.25586C4.91211 8.9502 5.47461 9.50391 6.16016 9.50391ZM10.291 9.09961H22.2266C22.7012 9.09961 23.0791 8.73047 23.0791 8.25586C23.0791 7.78125 22.71 7.41211 22.2266 7.41211H10.291C9.8252 7.41211 9.44727 7.78125 9.44727 8.25586C9.44727 8.73047 9.81641 9.09961 10.291 9.09961ZM6.16016 14.9092C6.85449 14.9092 7.4082 14.3555 7.4082 13.6611C7.4082 12.9756 6.85449 12.4131 6.16016 12.4131C5.47461 12.4131 4.91211 12.9756 4.91211 13.6611C4.91211 14.3555 5.47461 14.9092 6.16016 14.9092ZM10.291 14.5049H22.2266C22.7012 14.5049 23.0791 14.1357 23.0791 13.6611C23.0791 13.1865 22.71 12.8174 22.2266 12.8174H10.291C9.8252 12.8174 9.44727 13.1865 9.44727 13.6611C9.44727 14.1357 9.81641 14.5049 10.291 14.5049ZM6.16016 20.3145C6.85449 20.3145 7.4082 19.7607 7.4082 19.0664C7.4082 18.3809 6.85449 17.8184 6.16016 17.8184C5.47461 17.8184 4.91211 18.3809 4.91211 19.0664C4.91211 19.7607 5.47461 20.3145 6.16016 20.3145ZM10.291 19.9102H22.2266C22.7012 19.9102 23.0791 19.541 23.0791 19.0664C23.0791 18.5918 22.71 18.2227 22.2266 18.2227H10.291C9.8252 18.2227 9.44727 18.5918 9.44727 19.0664C9.44727 19.541 9.81641 19.9102 10.291 19.9102Z"
                    fill="#888888"
                  />
                </svg>
              </template>

              <template #cell-quantity="{data: item}">
                <BaseInput
                  :id="`${item.name}-${item.index}-${index}`"
                  placeholder="Nhập số lượng"
                  v-model="inventory.lineItemReqs[item.index].quantity"
                  type="unit"
                />
              </template>

              <template #cell-edit>
                <!-- <IconEditRecord
                  :options="optionsEdit"
                  @select="showPopup('chinh-sua-phien-ban')"
                /> -->
                <!-- <ItemEditVariation :data="inventory" @value="inventory"/> -->
              </template>
            </LayoutTable>
          </LayoutCard>
        </div>

        <ItemArrangeColumn
          v-model="fieldInventory"
        />
      </b-form>

      <LayoutPopup id="chinh-sua-ton-kho" size="small">
        <template #title>Bạn chưa lưu chỉnh sửa</template>
        <template #content>
          Mọi thông tin chỉnh sửa tồn kho của chi nhánh sẽ không được lưu lại.
          Bạn chắc muốn chuyển chi nhánh?
        </template>
        <template #control-right>
          <BaseButton
            size="sm"
            variant="secondary"
            @click="hidePopup('chinh-sua-ton-kho')"
          >
            Đóng
          </BaseButton>
          <BaseButton 
            size="sm" 
            @click="changeLocation"
          >
            Tiếp tục chuyển
          </BaseButton>
        </template>
      </LayoutPopup>

      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>
    </ValidationObserver>
  </Layout>
  <TheLayout v-else>
    <NotPermission></NotPermission>
  </TheLayout>
</div>
</template>

<script>
import VueCookies from 'vue-cookies';
import Swal from "sweetalert2";

import Layout from "@/router/layouts/item";
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";

import getListInventory from "@/mixins/items/getListInventory";
import getListLocation from "@/mixins/location/getListLocation";
import getDetailItem from "@/mixins/items/getDetailItem";
import handlerReqInventoryNewItem from "@/mixins/items/handlerReqInventoryNewItem"

import { ItemService } from "@/services/nextshop/item.service";
export default {
  components: {
    Layout,
    ItemArrangeColumn
  },

  mixins: [getListInventory, getListLocation, getDetailItem, handlerReqInventoryNewItem],

  data() {
    return {
      query : this.$route.query,
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      submit: false,
      loading: false,
      optionsEdit: [{ id: 0, text: "Chỉnh sửa" }],
      inventoryId: '',
      inventoryName: '',
      locationId:  VueCookies.get('LID'),
      locationIdTmp: '',
      locationName: this.getNameLocation(VueCookies.get('LID')),
      locationNameTmp: '',
      roleUser: JSON.parse(localStorage.getItem("auth.currentUser")).role,
      listLocation: [],
      listInventory: [],
      fieldInventory: [
        {
          label: "Phiên bản",
          key: "name",
          thStyle: { 
            width: "28%",
            'min-width': "150px"
          },
          show: true,
          disabled: true
        },
        {
          label: "SKU",
          key: "sku",
          thStyle: { 
            width: "27%",
            'min-width': "150px"
          },
          show: true,
          disabled: false
        },
        {
          label: "Tồn ban đầu",
          key: "quantity",
          thStyle: { 
            width: "20%",
            'min-width': "150px" 
          },
          show: true,
          disabled: true
        },
        {
          label: "Đơn vị tính",
          key: "unit",
          thStyle: { 
            width: "20%",
            'min-width': "100px"
          },
          show: true,
          disabled: false
        },
        {
          label: "",
          key: "edit",
          thStyle: { width: "5%" },
          show: true,
          disabled: false
        },
      ],
      Item: [],
      InventoryTmp: [],
      Inventory: [{
        options: [],
        inventoryId: '',
        locationId: '',
        lineItemReqs: [{
          name: '',
          sku: '',
          unit: '',
          quantity: 0,
          edit: ''
        }],
      }]
    }
  },

  async created() {
    this.loading = true
    this.listLocation = await this.getListLocation(this.roleUser)
    let locationActive = this.listLocation.find(e => e.coLocationId === this.locationId)
    this.listInventory = locationActive.inventories
    let inventoryDefault = this.listInventory.find(e => e.isDefault === true)
    if(inventoryDefault && inventoryDefault.coInventoryId !== ''){
      this.inventoryId = inventoryDefault.coInventoryId
      this.inventoryName = inventoryDefault.name
    }  
    await this.getDataItem();
    this.loading = false
  },

  methods: {
    getValueInput(value ,indexTable, indexRecord) {
      this.Inventory[indexTable].lineItemReqs[indexRecord].quantity = value
    },

    async changeLocation() {
      this.listInventory = []
      this.locationId = this.locationIdTmp;
      this.locationName = this.locationNameTmp;
      await this.checkInInventory('change_location')
      
      let locationActive = this.listLocation.find(e => e.coLocationId === this.locationId)
      
      this.listInventory = locationActive.inventories
      
      let inventoryDefault = this.listInventory.find((e) => e.isDefault === true);
      if(inventoryDefault && inventoryDefault.coInventoryId !== ''){
        this.inventoryId = inventoryDefault.coInventoryId;
        this.inventoryName = inventoryDefault.name;
      }

      this.hidePopup('chinh-sua-ton-kho')
    },

    async getValueLocationName($event) {
      if ($event.coLocationId != this.locationId) {
        this.locationIdTmp = $event.coLocationId
        this.locationNameTmp = $event.text
        this.showPopup('chinh-sua-ton-kho')
      }
    },

    async getDataItem() {
      let res =
      {
        categoryId: this.query.categoryId,
        itemId: this.query.itemId,
        itemPriceId: this.query.itemPriceId
      }
      try {
        this.Item = await this.getDetail(res)
        let formatData = {
          options: this.Item.options,
          lineItemReqs: this.Item.variations.map((e) => {
            return {
              ...e,
              name: e.name,
              sku: e.sku,
              unit: this.Item.unit.name,
              quantity: 0,
              edit: '',
            }
          })
        }
        this.Inventory = this.listLocation.map((e, index) => {
          return {
            ...formatData,
            lineItemReqs: formatData.lineItemReqs.map(lineItemReq => {
              return {
                ...lineItemReq, 
                index: index
              }
            }),
            locationId: e.coLocationId,
            locationName: this.getNameLocation(e.coLocationId),
            inventoryId: (e.inventories && e.inventories.length > 0) ? e.inventories[0].coInventoryId : '',
            inventoryName: (e.inventories && e.inventories.length > 0) ? e.inventories[0].name : '',
            name: ''
          }
        })
      } catch (error) {
        console.log(error);
      }
    },

    async checkInInventory(dataInventory) {
      const checkItem = dataInventory.lineItemReqs.find(item => this.checkNumReplaceComma(item.quantity) > 0)
      if(checkItem != undefined){
        const params = await this.handlerReqInventoryNewItem(this.Item, dataInventory)
        await ItemService.checkInInventory(params)
      }
    }
  },

  watch: {
    submit: {
      handler: async function() {
        this.loading = true
        for (let i = 0; i < this.Inventory.length; i++) {
          await this.checkInInventory(this.Inventory[i])
        }
        this.loading = false
        
        Swal.fire({
          icon: "success",
          title:
            '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
          html: `<span style="color:#9093A4; font-size: 14px;" >Tạo số lượng tồn kho thành công</span>`,
          confirmButtonText: "Xác nhận",
        }).then(() => {
          this.$router.push(`/items`);
        });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .Card {
    width: 100%;  

    &> *:not(:first-child) {
      margin-top: 24px;
    }
  }

  .Text_field {
    width: 100%;
    margin: 0;
    padding: 12px 0;
  }
</style>